<template>
	<div class="createorder_more" ref="createorder_more">
		<el-form ref="createorderform" :style="{ height: `${windowHeight}px`, 'overflow-y': 'scroll' }">
			<el-row>
				<el-col v-for="(item, index) in model1" :key="index" :span="24" v-if="item.l_mode == '快递服务'">
					<el-card class="box-card" :label="item.l_mode" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_mode }}</span>
						</div>
						<div class="inputBox">
							<el-form-item v-if="i.ishidden == 'False'" :label="i.showname" label-width="80px" size="mini" :key="idx" v-for="(i, idx) in item.children">
								<el-select
									:ref="i.colname"
									v-model="i.value"
									v-if="i.controltype == 'select' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
									@change="val => changeselect(val, i, index)"
								>
									<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.d_name">{{ opt.d_name }}</el-option>
								</el-select>
							</el-form-item>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :key="index" :span="12" v-if="(item.l_mode == '寄件人信息' || item.l_mode == '收件人信息') && item.ishidden == 'False'">
					<el-card class="box-card" :label="item.l_mode" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_mode }}</span>
						</div>
						<div class="inputBox">
							<el-form-item
								v-if="i.ishidden == 'False'"
								:class="['inputItem', i.controltype == 'textarea' ? 'col24' : 'col12']"
								:label="i.showname"
								label-width="80px"
								v-for="(i, idx) in item.children"
								:key="idx"
								size="mini"
							>
								<el-input
									v-if="i.controltype == 'text' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									:type="i.controltype"
									v-model="i.value"
									:ref="i.colname"
									@blur="val => checkinput(val, i, index)"
									@keyup.native="val => enterinput(val, i, index)"
								></el-input>
								<el-input
									v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									type="text"
									v-model="i.value"
									:ref="i.colname"
									@keyup.native="val => enterinput(val, i, index)"
									@change.native="val => text_change(val, i, index)"
								></el-input>
								<el-autocomplete
									:ref="i.colname"
									v-if="i.controltype == 'input_filter'"
									v-model="i.value"
									:fetch-suggestions="
										(queryString, cb) => {
											inputsuggestions(queryString, cb, i, index);
										}
									"
									:style="{ width: `${i.coltdwidth}px` }"
									value-key="showname"
									:trigger-on-focus="true"
									@keyup.native="val => enterinput(val, i, index)"
									@select="
										val => {
											handleSelect(val, i, index);
										}
									"
								></el-autocomplete>
								<!-- 地址联动 -->
								<el-select
									:ref="i.colname"
									v-model="i.value"
									filterable
									remote
									reserve-keyword
									placeholder="可输入关键词搜索"
									:remote-method="val => addrinput(val, i, index)"
									:loading="loading"
									v-if="i.controltype == 'addrinput' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<el-option disabled label="可输入关键词搜索" value=""></el-option>
									<el-option v-for="item in i.colsource" :key="item.showname" :label="item.showname" :value="item.showname"></el-option>
								</el-select>

								<el-input
									:ref="i.colname"
									v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									:type="i.controltype"
									v-model="i.value"
									class="input-with-search"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<div slot="append" v-if="i.colass == 'search'" @click="inputgroupsearch(i, index, idx)">
										<span style="padding:15px"><i class="el-icon-search"></i></span>
									</div>
								</el-input>

								<el-input
									:ref="i.colname"
									v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
									:type="i.controltype"
									v-model="i.value"
									@keyup.native="val => enterinput(val, i, index)"
								></el-input>
								<el-select
									:ref="i.colname"
									v-model="i.value"
									filterable
									remote
									reserve-keyword
									placeholder="可输入关键词搜索"
									:remote-method="val => remoteMethod(val, i, index)"
									:loading="loading"
									v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<el-option disabled label="可输入关键词搜索" value=""></el-option>
									<el-option v-for="item in i.colsource" :key="item.value" :label="item.title" :value="item.value"></el-option>
								</el-select>
								<el-select
									:ref="i.colname"
									v-model="i.value"
									v-if="i.controltype == 'select' && i.ishidden == 'False'"
									:style="{ width: `${i.coltdwidth}px` }"
									@keyup.native="val => enterinput(val, i, index)"
								>
									<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
								</el-select>
								<!-- :style="{width:`${i.coltdwidth}px`}" -->
								<el-checkbox
									v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
									:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
									:checked="i.coldefault == 1 ? true : false"
									@change="val => setcheck(val, i)"
								></el-checkbox>

								<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
							</el-form-item>
						</div>
					</el-card>
				</el-col>
				<el-col v-for="(item, index) in model1" :span="24" :key="index" v-if="item.l_mode == '包裹信息' && item.ishidden == 'False'">
					<el-card class="box-card" :label="item.showname" shadow="hover">
						<div slot="header" class="clearfix">
							<span>{{ item.l_mode }}-{{ index - packageindex + 1 }}</span>
						</div>
						<div>
							<el-row>
								<el-col v-for="(i, idx) in item.children" :key="idx" :span="12">
									<el-form-item
										v-if="
											(i.controltype == 'text' || 'textarea' || 'select' || 'checkbox' || 'combox-checkbox') &&
												i.controltype != 'table' &&
												i.ishidden == 'False'
										"
										:label="i.showname"
										label-width="80px"
										size="mini"
									>
										<div v-if="i.controltype == 'text' || i.controltype == 'textarea'">
											<el-input
												:ref="i.colname"
												v-model="i.value"
												type="i.controltype"
												:style="{ width: `${i.coltdwidth}px` }"
												@keyup.native="val => enterinput(val, i, index)"
											></el-input>
											<span class="input_tips">{{ i.colass }}</span>
										</div>
										<el-select v-model="i.value" v-if="i.controltype == 'select' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }">
											<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
										</el-select>
										<label v-if="i.controltype == 'checkbox' && i.ishidden == 'False'">
											<el-checkbox
												:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
												v-model="i.value"
												:true-label="1"
												:false-label="0"
												:checked="i.value == '1' ? true : false"
											></el-checkbox>
										</label>
										<div v-if="i.controltype == 'combox-checkbox' && i.ishidden == 'False'">
											<el-checkbox
												:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
												true-label="1"
												false-label="0"
												:checked="i.value != '' && i.value != '0.00' ? true : false"
												@change="val => checkchange(val, i.colname +'_'+index, i)"
											></el-checkbox>
											<el-input
												:style="{
													width: `${i.coltdwidth}px`,
													marginLeft: `10px`,
													display: `${i.value != '' && i.value != '0.00' ? 'inline-block' : 'none'}`
												}"
												:ref="i.colname +'_'+index"
												type="text"
												v-model="i.value"
												placeholder="请输入保险金额"
												@keyup.native="val => enterinput(val, i, index)"
											></el-input>
											<span
												:ref="i.colname +'_'+index+ '_span'"
												class="checkbox_input_tips"
												:style="{ display: `${i.value != '' && i.value != '0.00' ? 'inline-block' : 'none'}` }"
											>
												注：USPS服务不支持购买保险
											</span>
										</div>
										<div v-else class="tiji">
											<span v-for="(tj, ti) in i.combox" :key="ti">
												{{ tj.showname }}
												<el-input style="width:50px;margin-right:10px" v-model="tj.value"></el-input>
											</span>
										</div>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-button type="primary" size="mini" style="margin-left:10px" @click="addpackage(item, index)" v-if="index == model1.length - 1">
									添加包裹
								</el-button>
								<el-button
									size="mini"
									type="warning"
									style="margin-left:10px"
									@click="removepackage(index)"
									v-if="index > packageindex || model1.length > packageindex + 1"
								>
									移除包裹
								</el-button>
							</el-row>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</el-form>
		<el-row v-if="model1.length > 0" class="footerhandler">
			<el-col :span="5" class="submitBtn_switch" style="color:transparent;">1</el-col>
			<el-col :span="6" class="submitBtn"><div @click="getrate">获取报价</div></el-col>
			<el-col :span="8" class="submitBtn_switch"></el-col>
		</el-row>
		<el-dialog :visible.sync="showratewin" title="报价单" width="700px" :close-on-click-modal="false" lock-scroll :append-to-body="true" :show-close="true">
			<tableui
				style="width:100%;margin-top:-10px"
				v-loading="loading"
				ref="ratelist"
				editcell="0"
				class="ratelist"
				:tableData="ratelist"
				:columns="columns"
				:gridheight="gridheight"
			></tableui>
			<span slot="footer" class="dialog-footer">
				<el-row>
					<el-col :span="20">
						<span style="font-size:12pt;color:transparent;">1</span>
					</el-col>
					<el-col :span="4" style="text-align: right;"><el-button @click="ratehandle" size="medium" type="success">创建订单</el-button></el-col>
				</el-row>
			</span>
		</el-dialog>
		<el-dialog :visible.sync="showaddrwin" title="地址簿" width="600px" :close-on-click-modal="false" lock-scroll :show-close="true" :append-to-body="true">
			<addresslist
				:type="addrtype"
				:addrsearchkey="addrsearchkey"
				:modelindex="modelindex"
				:childrenindex="childrenindex"
				ref="addresslist"
				@rebackaddr="rebackaddr"
			></addresslist>
		</el-dialog>
		<el-dialog :visible.sync="showsuccesswin" title="操作提示" width="600px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<el-row style="padding-bottom:20px;margin-top:-20px">
				<el-col style="text-align:center">
					<i class="el-icon-success" style="color:#80CBC4;font-size:55pt;" v-if="(showpdf != '' && errorfile == '') || (showpdf == '' && errorfile == '')"></i>
					<i class="el-icon-warning" style="color:#e6a727;font-size:55pt;" v-if="showpdf != '' && errorfile != ''"></i>
					<i class="el-icon-error" style="color:#e27b20;font-size:55pt;" v-if="showpdf == '' && errorfile != ''"></i>
					<br />
					<br />
					<span style="font-size:20pt;font-weight: bold" v-if="(showpdf != '' && errorfile == '') || (showpdf == '' && errorfile == '')">下单成功</span>
					<span style="font-size:13pt;font-weight: bold" v-if="showpdf != '' && errorfile != ''">部分包裹下单成功，未成功包裹请点击下面失败详情按钮查看原因</span>
					<span style="font-size:13pt;font-weight: bold" v-if="showpdf == '' && errorfile != ''">下单失败，请点击下面失败详情按钮查看原因</span>
				</el-col>
			</el-row>
			<el-row v-if="errorfile == ''">
				<el-col :span="7" style="text-align:right;padding-right:10px;">
					<el-button type="warning" size="medium" @click="perviewmd">
						预览面单
					</el-button>
				</el-col>
				<el-col :span="6" style="text-align:left;"><el-button type="primary" size="medium" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="5" style="text-align:right;"><el-button type="success" size="medium" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="4" style="text-align: center;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
			<el-row v-if="errorfile != ''">
				<el-col :span="4" style="text-align:center;">
					<el-button type="warning" size="medium" @click="perviewmd">
						预览面单
					</el-button>
				</el-col>
				<el-col :span="5" style="text-align:center;" v-if="errorfile != ''">
					<el-button type="danger" size="medium"><a :href="errorfile" target="_blank" style="color:#ffffff;text-decoration:none;">失败详情</a></el-button>
				</el-col>
				<el-col :span="6" style="text-align:center;"><el-button type="primary" size="medium" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="5" style="text-align:right;"><el-button type="success" size="medium" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="4" style="text-align: center;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row>
			
			<el-row style="margin-top:25px">
				<el-col :span="2" style="color:transparent">1</el-col>
				<el-col :span="20">
					<el-link @click="wintips=true" style="color:#409EFF">预览没反应？请点这里查看解决方案</el-link>
				</el-col>
			</el-row>
			<!-- <el-row v-if="errorfile == ''">
				<el-col :span="10" style="text-align:right;"><el-button type="primary" size="medium" @click="successfun(1)">复制上一单新增</el-button></el-col>
				<el-col :span="6" style="text-align:center;"><el-button type="success" size="medium" @click="successfun(2)">添加新订单</el-button></el-col>
				<el-col :span="6" style="text-align:left;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row> -->
		<!-- 	<el-row v-if="showpdf == '' && errorfile != ''">
				<el-col :span="12" style="text-align:right;">
					<el-button type="danger" size="medium"><a :href="errorfile" style="color:#ffffff;text-decoration:none;">失败详情</a></el-button>
				</el-col>
				<el-col :span="1" style="color:transparent">11</el-col>
				<el-col :span="11" style="text-align:left;"><el-button size="medium" @click="successfun(0)">关闭</el-button></el-col>
			</el-row> -->
		</el-dialog>
		<el-dialog :visible.sync="wintips" center width="70%" :close-on-click-modal="true" :show-close="true" :append-to-body="true">
			<img src="../../static/system_01/image/tips.png" style="width:100%" />
		</el-dialog>
		<printhandler ref="printhandler"></printhandler>
	</div>
</template>
<script>
import tableui from '@/components/table/tablegrid.vue';
import sendtype from '@/components/order/sendtype.vue';
import addresslist from '@/components/address/addresslist.vue';
import printhandler from '@/components/order/printhandler.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		sendtype,
		addresslist,
		printhandler
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		},
		curpkval: {
			type: String,
			default: ''
		},
		iscopy: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 150,
			model1: [],
			isEnable: true,
			pkval: '', //修改时此值不为空
			p_pkval: '',
			cargolist: [],
			orderinfo: {},
			mode: '',
			ratelist: [], //报价单
			columns: [{ field: 'expresscom', title: '物流公司', type: 'text', sortable: false, width: 150 },
				{ field: 'servicetype', title: '线路名称', type: 'text', sortable: false, width: 150 },
				{ field: 'amount', title: '价格', type: 'text', sortable: false, width: 150 }
			], //报价单列表表头
			loading: false,
			showratewin: false,
			gridheight:'250px',
			expresscom: '',
			expresscomname:'',
			expresscomid: '', //选择的物流公司唯一id
			rateid: '', //报价单唯一id
			servicetypeid: '', //服务类型编码
			residential: 0, //寄件地址是否为家庭住址
			cgresidential: 0, //收件地址是否为家庭住址
			showaddrwin: false,
			addrtype: '0', //地址标识 1-寄件地址 0-收件地址
			modelindex: -1,
			childrenindex: -1,
			addrsearchkey: '',
			type: '多件下单',
			addressinfo: '', //默认寄件地址
			ecode: '',
			divclass: 'ratelist',
			vipaccount: '',
			packageindex: -1,
			rateamount: 0, //总报价
			userid: localStorage.getItem('userid'),
			showpdf: '', //面单地址
			showsuccesswin: false,
			errorfile: '',
			batch:'',
			p_mode:'',
			wintips:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/logisticsmanager/createorder_more.scss');
		});
		var that = this;
		//设置列表兼容性
		setTimeout(() => {
			if (that.$refs.cargo != undefined) {
				if (that.$refs.cargo.length > 0) {
					that.$refs.cargo[0].$refs.tablegrid.doLayout();
				}
			}
		}, 300);
		this.vipaccount = localStorage.getItem('vipaccount');
	},
	methods: {
		init(param) {
			this.$tool.loading('正在加载', 'createorder_more');
			this.GetDefaultaddr();
		},
		//获取默认寄件地址
		GetDefaultaddr() {
			var that = this;
			this.$apipost.get.GetDefaultCtaddr().then(res => {
				if (res.addressinfo != undefined && res.addressinfo != '') {
					that.addressinfo = res.addressinfo;
				}
				that.GetPageLayoutSet();
			});
		},
		//获取排版信息
		GetPageLayoutSet() {
			var that = this;
			this.$apipost.get.CreatePageLayoutByPmode({ sys: '出口系统', fun: '批量下单', type: this.type, p_mode: '' }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if (res.list.length > 0) {
						that.model1 = [];
						that.SetPageLayout(res.list);
					}
				}
			});
		},
		//设置排版
		SetPageLayout(list) {
			var index = 0;
			var that = this;
			var isorderinfo = false;
			that.model1 = list;
			list.forEach(e => {
				if (e.ishidden == 'False') {
					if (e.l_mode == '包裹信息') {
						that.packageindex = index;
						e.children.forEach(cargo => {
							if (isorderinfo) {
								if (cargo.controltype == 'combox-input' && cargo.ishidden == 'False') {
									var volume = cargo.combox;
									cargo.combox.forEach(com => {
										for (var key in that.orderinfo.baginfo) {
											if (com.colname == key) {
												com.value = that.orderinfo.baginfo[key];
											}
										}
									});
								} else {
									if (cargo.ishidden == 'False') {
										for (var key in that.orderinfo.baginfo) {
											if (cargo.colname == key) {
												cargo.value = that.orderinfo.baginfo[key];
											}
										}
									}
								}
							}
							else{
								cargo.value = cargo.coldefault;
							}
						});
					}
					if (e.l_mode == '寄件人信息') {
						if (isorderinfo) {
							e.children.forEach(sender => {
								for (var key in that.orderinfo.sender) {
									if (sender.colname == key) {
										sender.value = that.orderinfo.sender[key];
										if (sender.value == '' || sender.value == undefined) {
											sender.value = sender.coldefault;
										}
									}
								}
							});
						} else {
							e.children.forEach(sender => {
								if (that.addressinfo != '') {
									var addressinfo = JSON.parse(JSON.stringify(that.addressinfo));
									for (var key in addressinfo) {
										if (sender.colname == key) {
											sender.value = addressinfo[key];
										}
										if (sender.value == '' || sender.value == undefined) {
											sender.value = sender.coldefault;
										}
									}
								} else {
									sender.value = sender.coldefault;
								}
							});
						}
					}
					if (e.l_mode == '收件人信息') {
						if (isorderinfo) {
							e.children.forEach(receiver => {
								for (var key in that.orderinfo.receiver) {
									if (receiver.colname == key) {
										receiver.value = that.orderinfo.receiver[key];
										if (receiver.value == '' || receiver.value == undefined) {
											receiver.value = receiver.coldefault;
										}
									}
								}
							});
						} else {
							e.children.forEach(receiver => {
								if (receiver.value == '' || receiver.value == undefined) {
									receiver.value = receiver.coldefault;
								}
							});
						}
					}
				}
				index++;
			});
		},
		//报价单列表操作事件
		ratehandle() {
			var that = this;
			that.rateid=that.ratelist[0].id;
			that.expresscomname=that.ratelist[0].expresscom;
			that.expresscomid = that.ratelist[0].e_code; //下单唯一id
			that.servicetypeid = that.ratelist[0].servicetypeid; //
			that.residential = that.ratelist[0].residential;
			that.cgresidential = that.ratelist[0].cgresidential;
			that.p_mode=that.ratelist[0].p_mode;
			
			that.saveorder();
		},
		//保存订单
		saveorder() {
			var that = this;
			this.$tool.loadingclose();
			var isgo = true;
			var orderinfo = {};
			orderinfo = that.getorderObj(JSON.parse(JSON.stringify(this.model1)), orderinfo, true);
			if (orderinfo.receiver != undefined) {
				this.$tool.loading('正在保存', 'ratelist');
				//console.log('正在保存 ' + this.$tool.getcurrenttime());
				//console.log('orderinfo',escape(JSON.stringify(orderinfo)));
				//return false;
				// if (1 > 0) {
				// 	return false;
				// }
				
				this.$apipost.post.SaveOrder_More({ orderinfo: orderinfo }).then(res => {
					if (res != '') {
						this.$tool.loadingclose();
						if (res.state == '1') {
							//console.log('批次',res.batch);
							that.pkval=res.pkval;
							that.batch=res.batch;
							that.goprint();
						} else {
							this.$tool.message(res.message, 0);
						}
					}
				});
			}
		},
		//获取订单实体信息
		getorderObj(model1, orderinfo, iserror) {
			var that = this;
			orderinfo = {
				u_userid: localStorage.getItem('userid'),
				u_account: localStorage.getItem('u_account'),
				u_name: localStorage.getItem('u_name'),
				u_company: localStorage.getItem('u_company'),
				pkval: this.pkval,
				p_pkval: this.p_pkval,
				p_mode:this.p_mode,
				p_sys:'境内包裹'
			};
			var error = '';
			orderinfo.p_pkval = '';
			var packageinfo = {};
			var packageindex = 0;
			for (var i = 0; i < model1.length; i++) {
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '快递服务' && model1[i].ishidden == 'False') {
						var children = model1[i].children;
						var expressinfo = '';
						for (var j = 0; j < children.length; j++) {
							if (children[j].value == undefined) {
								children[j].value = '';
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写' + children[j].showname;
								if (iserror) {
									expressinfo = '';
									break;
								}
							} else {
								for (var e = 0; e < children[j].colsource.length; e++) {
									if (children[j].colname == 'ecode') {
										if (children[j].colsource[e].d_name == children[j].value) {
											expressinfo += '"' + children[j].colname + '":"' + children[j].colsource[e].id + '",';
											break;
										}
									}
									if (children[j].colname == 'servicetypeid') {
										if (children[j].colsource[e].d_name == children[j].value) {
											expressinfo += '"' + children[j].colname + '":"' + children[j].colsource[e].d_value + '",';
											break;
										}
									}
								}
							}
						}
						if (expressinfo != '') {
							expressinfo = expressinfo.replace(/\n/g, '');
							expressinfo = '{' + expressinfo.substring(0, expressinfo.length - 1) + '}';
							orderinfo.expressinfo = JSON.parse(expressinfo);
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '寄件人信息' && model1[i].ishidden == 'False') {
						var sender = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].value == undefined) {
								children[j].value = '';
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写寄件人' + children[j].showname;
								if (iserror) {
									sender = '';
									break;
								}
							}
							if (iserror) {
								if (children[j].ishidden == 'False') {
									sender += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								sender += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (sender != '') {
							sender = sender.replace(/\n/g, '');
							sender = '{' + sender.substring(0, sender.length - 1) + '}';
							orderinfo.sender = JSON.parse(sender);
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '收件人信息' && model1[i].ishidden == 'False') {
						var receiver = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].value == undefined) {
								children[j].value = '';
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写收件人' + children[j].showname;
								if (iserror) {
									receiver = '';
									break;
								}
							}
							if (iserror) {
								if (children[j].ishidden == 'False') {
									receiver += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								receiver += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (receiver != '') {
							receiver = receiver.replace(/\n/g, '');
							receiver = '{' + receiver.substring(0, receiver.length - 1) + '}';
							orderinfo.receiver = JSON.parse(receiver);
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '包裹信息') {
						packageinfo = {};
						var isnocargo = false;
						var baginfo = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype != 'table') {
								if (children[j].controltype == 'combox-input' && children[j].isnull == 'False') {
									var volume = children[j].combox;
									for (var k = 0; k < volume.length; k++) {
										if (volume[k].value == undefined) {
											volume[k].value = '';
										}
										if (volume[k].isnull == 'False' && volume[k].value == '') {
											error = '请填写' + volume[k].showname;
											if (iserror) {
												break;
											}
										}
										if (iserror) {
											if (volume[k].ishidden == 'False') baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
										} else {
											baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
										}
									}
									if (error != '') {
										if (iserror) {
											baginfo = '';
											break;
										}
									}
								} else {
									if (children[j].value == undefined) {
										children[j].value = '';
									}
									if (children[j].isnull == 'False' && children[j].value == '') {
										error = '请填写' + children[j].showname;
										if (iserror) {
											break;
										}
									}
									if (iserror) {
										if (children[j].ishidden == 'False') baginfo += '"' + children[j].colname + '":"' + children[j].value + '",';
									} else {
										baginfo += '"' + children[j].colname + '":"' + children[j].value + '",';
									}
								}
							} else {
								if (children[j].ishidden == 'True') {
									isnocargo = true;
								}
							}
						}
						if (error == '' || !iserror) {
							if (baginfo != '') {
								baginfo = baginfo.replace(/\n/g, '');
								baginfo = '{' + baginfo.substring(0, baginfo.length - 1) + '}';
								packageinfo.baginfo = JSON.parse(baginfo);
							}
							if (!isnocargo) {
								packageinfo.cargolist = that.cargolist;
							}
							if (packageinfo.length == 0) {
								if (!isnocargo) error = '请填写包裹信息';
							} else {
								var content = '';
								if (packageinfo.cargolist != undefined) {
									packageinfo.cargolist.forEach(e => {
										if (e.cnameall != undefined) {
											content += e.cnameall + ' ' + e.num + '  ';
										} else {
											if (e.brand != undefined) {
												content += e.brand + ' ';
											}
											if (e.cname != undefined) {
												content += e.cname + ' ';
											}
											if (e.spec != undefined) {
												content += e.spec + ' ';
											}
											content += e.num + ' ';
											if (e.unit != undefined) {
												content += e.unit + ' ';
											}
										}
									});
								}
								packageinfo.p_content = content;
							}
						}
						if (error == '' || !iserror) {
							packageinfo.packageindex = packageindex;
							if (orderinfo.orderlist == undefined) {
								orderinfo.orderlist = [
									{
										packageinfo: JSON.parse(JSON.stringify(packageinfo))
									}
								];
							} else {
								orderinfo.orderlist.push({
									packageinfo: JSON.parse(JSON.stringify(packageinfo))
								});
							}
							packageindex++;
						}
					}
				}
				if (error == '' || !iserror) {
					if (model1[i].l_mode == '附加信息' && model1[i].ishidden == 'False') {
						var extend = '';
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype == 'checkbox') {
								if (children[j].coldefault) {
									children[j].value = '1';
								} else {
									children[j].value = '0';
								}
							} else {
								if (children[j].value == undefined) {
									children[j].value = '';
								}
							}
							if (children[j].isnull == 'False' && children[j].value == '') {
								error = '请填写' + children[j].showname;
								if (iserror) {
									extend = '';
									break;
								}
							}
							if (iserror) {
								if (children[j].ishidden == 'False') {
									extend += '"' + children[j].colname + '":"' + children[j].value + '",';
								}
							} else {
								extend += '"' + children[j].colname + '":"' + children[j].value + '",';
							}
						}
						if (extend != '') {
							extend = extend.replace(/\n/g, '');
							extend = '{' + extend.substring(0, extend.length - 1) + '}';
							orderinfo.extend = JSON.parse(extend);
						}
					}
				}
				if (error != '' && iserror) {
					this.$tool.message(error, 0);
					break;
				}
			}
			if (error != '' && iserror) {
				orderinfo = {};
			}
			//console.log('订单信息', JSON.stringify(orderinfo));
			return orderinfo;
		},
		//获取报价单
		getrate() {
			var that = this;
			this.$tool.loadingclose();
			if (that.$refs.ratelist != undefined) {
				that.$refs.ratelist.$refs.tablegrid.doLayout();
			}
			var orderinfo = {};
			orderinfo = that.getorderObj(JSON.parse(JSON.stringify(this.model1)), orderinfo, true);
			orderinfo.vipaccount = that.vipaccount;
			if (orderinfo.receiver != undefined) {
				// console.log('获取报价 ' + escape(JSON.stringify(orderinfo)));
				// if (2 > 1) return false;
				this.$tool.loading('正在获取', 'createorder_more');
				this.$apipost.get.GetRate({ orderinfo: orderinfo }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						//console.log('报价完成' + this.$tool.getcurrenttime());
						if (res.ratelist.length > 0) {
							that.showratewin = true;
							that.ratelist = res.ratelist;
						} else {
							if (res.message != undefined) {
								this.$tool.message(res.message, 0);
							} else {
								this.$tool.message('未获取到报价信息', 0);
							}
						}
					}
				});
			}
		},
		//打印
		goprint() {
			this.$tool.loadingclose();
			var that = this;
			var isrollback = true;
			//console.log('正在下单 ' + this.$tool.getcurrenttime());
			this.$tool.loading('正在下单', 'ratelist');
			if (that.$refs.printhandler != undefined) {
				that.$refs.printhandler.init({
					pageparam: this._data,
					isgrid: false,
					searchinfo: '',
					funcode: '05', //funcode --01从获取用户权限内的打印模板开始的
					handtype: 9, //1--取单号 2--取快递单并打印 3-取快递单并预览
					isrollback: isrollback,
					parentpage: this,
					batch:that.batch,
					ecode:that.expresscomid,
					expresscomname:that.expresscomname
				});
			}
		},
		//远程搜索option（国家）
		remoteMethod(query, i) {
			var that = this;
			if (query != '') {
				setTimeout(function() {
					if (i.colname.indexOf('country') > 0) {
						that.$apipost.get.GetCountry({ searchkey: query }).then(res => {
							if (res != '') {
								i.colsource = res.list;
							}
						});
					}
				}, 100);
			}
		},
		//带搜索的输入框
		inputgroupsearch(i, modelindex, childrenindex) {
			if (i.colname == 'ctcompany' || i.colname == 'ctname') {
				//按公司名搜索地址库
				this.addrtype = '1';
			} else if (i.colname == 'cgcompany' || i.colname == 'cgname') {
				this.addrtype = '0';
			}
			this.modelindex = modelindex;
			this.childrenindex = childrenindex;
			this.addrsearchkey = i.value;
			if (this.$refs.addresslist != undefined) {
				this.$refs.addresslist.init({ type: this.addrtype, addresskey: i.value, modelindex: modelindex, childrenindex: childrenindex });
			}
			this.showaddrwin = true;
		},
		//选地址回填
		rebackaddr(e) {
			var that = this;
			this.model1[e.modelindex].children.forEach(item => {
				if (that.addrtype == '1') {
					if (item.colname == 'ctcompany') item.value = e.row.company;
					if (item.colname == 'ctname') item.value = e.row.name;
					if (item.colname == 'ctphone') item.value = e.row.phone;
					if (item.colname == 'ctpostcode') item.value = e.row.postcode;
					if (item.colname == 'ctcountry') item.value = e.row.country;
					if (item.colname == 'ctprovince') item.value = e.row.province;
					if (item.colname == 'ctcity') item.value = e.row.city;
					if (item.colname == 'ctdetailaddr') item.value = e.row.street + e.row.detailaddr;
				} else {
					if (item.colname == 'cgcompany') item.value = e.row.company;
					if (item.colname == 'cgname') item.value = e.row.name;
					if (item.colname == 'cgphone') item.value = e.row.phone;
					if (item.colname == 'cgpostcode') item.value = e.row.postcode;
					if (item.colname == 'cgcountry') item.value = e.row.country;
					if (item.colname == 'cgprovince') item.value = e.row.province;
					if (item.colname == 'cgcity') item.value = e.row.city;
					if (item.colname == 'cgdetailaddr') item.value = e.row.street + e.row.detailaddr;
				}
			});
			this.showaddrwin = false;
		},
		//操作完成
		successfun(type) {
			var that = this;
			that.showsuccesswin = false;
			that.showratewin = false;
			if (type == 0) {
				Utils.$emit('handleRermove',localStorage.getItem('tabname'));
			} else if (type == 1) {
				//保留界面上的信息，再下新单
				that.clearinput(false);
			} else if (type == 2) {
				//新增订单，清空界面上所有填写的
				that.clearinput(true);
			}
		},
		clearinput(clearall) {
			var that = this;
			that.p_pkval = '';
			that.pkval = '';
			that.showpdf = false;
			that.residential = 0;
			var model1 = that.model1;
			if (clearall) {
				for (var i = 0; i < model1.length; i++) {
					if (model1[i].l_mode == '快递服务') {
						model1[i].value = '';
					}
					if (model1[i].l_mode == '寄件人信息' || model1[i].l_mode == '收件人信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].coldefault != '') children[j].value = children[j].coldefault;
							else children[j].value = '';
						}
						if (model1[i].l_mode == '寄件人信息') {
							if (that.addressinfo != '') {
								var addressinfo = JSON.parse(JSON.stringify(that.addressinfo));
								model1[i].children.forEach(sender => {
									for (var key in addressinfo) {
										if (sender.colname == key) {
											sender.value = addressinfo[key];
										}
										if (sender.value == '' || sender.value == undefined) {
											sender.value = sender.coldefault;
										}
									}
								});
							}
						}
					}
					if (model1[i].l_mode == '包裹信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype != 'table') {
								if (children[j].controltype == 'combox-input') {
									var volume = children[j].combox;
									for (var k = 0; k < volume.length; k++) {
										volume[k].value = '';
									}
								} else children[j].value = '';
							} else {
								that.cargolist = [];
							}
						}
					}
					if (model1[i].l_mode == '附加信息') {
						var children = model1[i].children;
						for (var j = 0; j < children.length; j++) {
							if (children[j].controltype == 'checkbox') {
								if (children[j].coldefault) {
									children[j].value = '1';
								} else {
									children[j].value = '0';
								}
							} else {
								children[j].value = '';
							}
						}
					}
				}
			}
		},
		//地址联动选择
		addrinput(val, i, modelindex) {
			this.$tool.addrlink(this, val, modelindex, i);
		},
		//文本框输入时自动提示
		inputsuggestions(querystring, cb, i, modelindex) {
			if (i.colevent != '') {
				this.$tool.addrlink_call(this, modelindex, i, cb);
			}
		},
		//选中提示选项时
		handleSelect(item, i, modelindex) {
			var that = this;
		},
		//文本框改变
		text_change(val, i, modelindex) {
			if (i.colevent != '') {
				this.$tool.addrlink(this, val, modelindex, i);
			}
		},
		enterinput(event, i, modelindex) {
			//console.log(val);
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') this.$refs[i.colnext][0].focus();
				} else if (event.keyCode == 37) {
					if (i.colperv != '') this.$refs[i.colperv][0].focus();
				}
			}
		},
		checkchange(val, control, i) {
			if (val == '1') {
				this.$refs[control][0].$el.style.display = 'inline-block';
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'inline-block';
				}
			} else {
				if (i != undefined) i.value = '';
				this.$refs[control][0].$el.style.display = 'none';
				if (this.$refs[control + '_span'] != undefined) {
					this.$refs[control + '_span'][0].style.display = 'none';
				}
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		changeselect(val, i, index) {
			var that = this;
			var filterval = '';
			//筛选服务
			if (i.colnext != '') {
				that.model1[index].children.forEach(e => {
					if (e.colname == i.colnext) {
						e.colsource = [];
						e.value = '';
					}
					if (e.colname == i.colname) {
						e.colsource.forEach(j => {
							if (j.d_name == val) {
								filterval = j.d_value;
							}
						});
					}
				});
				that.$apipost.get.dic({ type: '服务类型' }).then(res => {
					if (res != '') {
						var list = res.data.list;
						if (list.length > 0) {
							var filterlist = list.filter(function(e) {
								return e.remark == filterval;
							});
							that.model1[index].children.forEach(e => {
								if (e.colname == i.colnext) {
									e.colsource = filterlist;
									if (filterlist.length > 0) e.value = filterlist[0].d_name;
								}
							});
						}
					}
				});
			}
		},
		//添加包裹
		addpackage(item, index) {
			this.model1.push(JSON.parse(JSON.stringify(item)));
			var modeitem = this.model1[parseInt(index) + 1]; //JSON.parse(JSON.stringify(item));
			modeitem.children.forEach(e => {
				if (e.coldefault != '') e.value = e.coldefault;
				else {
					if (e.combox != undefined) {
						e.combox.forEach(com => {
							com.value = '';
						});
					} else {
						e.value = '';
					}
				}
			});
			//滚动条滚到底
			this.$nextTick(() => {
				this.$refs.createorderform.$el.scrollTop = this.$refs.createorderform.$el.scrollHeight;
			});
		},
		//移除包裹
		removepackage(index) {
			this.model1.splice(index, 1);
		},
		checkinput(event, i, modelindex){
			if(i.colname == 'ctphone'||i.colname == 'cgphone'){
				if(i.value!=''){
					if(i.coltype=='phone_10'){
						if(i.value.length<10){
							this.$tool.message(i.showname+'不能少于10位', 0);
							this.$refs[i.colname][0].focus();
						}
					}	
				}
			}
		},
		//预览面单
		perviewmd() {
			this.$tool.loading('正在获取打印模板', 'createorder_more');
			this.batch='';
			this.$refs.printhandler.init({
				pageparam: this._data,
				isgrid: false,
				pkval: this.pkval,
				searchinfo: '',
				funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
				handtype: 3, //1--取单号 2--取快递单并打印 3-取快递单并预览
				isrollback: false,
				ecode: this.expresscomid,
				expresscomname: this.expresscomname,
				parentpage: this,
				isprint: 0
			});
		}	
	}
};
</script>
